// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"315":"about-app","354":"samples-preview","825":"about-sonic-pi"}[chunkId] + "." + {"315":"80edb786","354":"2b9ea966","825":"e90d4541"}[chunkId] + ".js";
};